<div class="r184-resumen">
  <div class="r184-resumen__item">
    <span class="r184-resumen__label">Registros de la entidad</span>
    <strong>{{ data?.numeroRegistrosEntidad | number:'1.0-0' }}</strong>
  </div>
</div>

<ng-template #estadoTpl let-valor let-row="row">
  <span class="r184-estado" [class.r184-estado--error]="valor > 0">
    <mat-icon>{{ valor > 0 ? 'error' : 'check_circle' }}</mat-icon>
    {{ valor > 0 ? valor + (valor === 1 ? ' error' : ' errores') : 'Correcto' }}
  </span>
</ng-template>

<ng-template #origenTpl let-valor let-row="row">
  <span class="r184-origen r184-origen--{{ valor | lowercase }}">
    {{ valor === 'CALCULADO' ? 'Calculado' : valor === 'IMPORTADO' ? 'Importado' : 'Manual' }}
  </span>
</ng-template>

<ng-template #ingresosTpl let-valor let-row="row">
  <span class="r184-importe">
    {{ formatoImporte(valor) }}
    <button type="button" class="r184-help" *ngIf="conOrigen(row, 'ingresos')"
      (click)="origen.emit({ indice: row.indice, campo: 'ingresos' })"
      matTooltip="Ver de dónde sale este importe">?</button>
  </span>
</ng-template>

<ng-template #gastosTpl let-valor let-row="row">
  <span class="r184-importe">
    {{ formatoImporte(valor) }}
    <button type="button" class="r184-help" *ngIf="conOrigen(row, 'gastos')"
      (click)="origen.emit({ indice: row.indice, campo: 'gastos' })"
      matTooltip="Ver de dónde sale este importe">?</button>
  </span>
</ng-template>

<ng-template #retencionesTpl let-valor let-row="row">
  <span class="r184-importe">
    {{ formatoImporte(valor) }}
    <button type="button" class="r184-help" *ngIf="conOrigen(row, 'retenciones')"
      (click)="origen.emit({ indice: row.indice, campo: 'retenciones' })"
      matTooltip="Ver de dónde sale este importe">?</button>
  </span>
</ng-template>

<div class="cf-table-card">
  <app-custom-table #table="customTable" [config]="tableConfig"></app-custom-table>
</div>
